import React, { Component } from 'react';
import PropTypes from 'prop-types';

class AudioPackSelector extends Component {
  renderPacks = packs => packs.map(pack => (
    <AudioPackButton
      key={pack.id}
      title={pack.title}
      subtitle={pack.subtitle}
      banner={pack.banner}
      selected={this.isPackSelected(pack)}
      onSelect={() => this.handlePackSelect(pack)}
      disabled={pack.disabled}
    />
  ))

  isPackSelected = pack => (pack.id === this.props.selectedPackId);

  handlePackSelect = (pack) => {
    const { onPackSelect } = this.props;

    if (pack.disabled) {
      return;
    }

    onPackSelect(pack);
  }

  render() {
    const { packs } = this.props;

    return (
      <div className="audio-pack-selector">
        {this.renderPacks(packs)}
      </div>
    );
  }
}

AudioPackSelector.propTypes = {
  packs: PropTypes.array.isRequired,
  onPackSelect: PropTypes.func,
  selectedPackId: PropTypes.string,
};

function AudioPackButton(props) {
  const {
    banner,
    title,
    subtitle,
    selected,
    onSelect,
    disabled,
  } = props;

  let rootClasses = 'audio-pack-btn';
  if (selected) {
    rootClasses += ' audio-pack-btn--selected';
  }
  if (disabled) {
    rootClasses += ' audio-pack-btn--disabled';
  }

  return (
    <div className={rootClasses} onClick={onSelect}>
      {banner ? (
        <div className="audio-pack-btn__banner">
          {banner}
        </div>
      ) : null}
      <div className="audio-pack-btn__title">
        {title}
      </div>
      <div className="audio-pack-btn__subtitle">
        {subtitle}
      </div>
    </div>
  );
}

export default AudioPackSelector;
